/**
 * 判断是否为空
 */
export function empty(value) {
  switch (typeof value) {
    case 'undefined':
      return true;
    case 'string':
      if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
      break;
    case 'boolean':
      if (!value) return true;
      break;
    case 'number':
      if (0 === value || isNaN(value)) return true;
      break;
    case 'object':
      if (null === value || value.length === 0) return true;
      for (var _i in value) {
        return false;
      }
      return true;
  }
  return false;
}


/*函数节流*/
export function throttle(fn, interval) {

  var enterTime = 0; //触发的时间
  var gapTime = interval || 1000; //间隔时间，如果interval不传，则默认300ms
  return function () {
    var context = this;
    var backTime = new Date(); //第一次函数return即触发的时间
    if (backTime - enterTime > gapTime) {
      fn.call(context, arguments);
      enterTime = backTime; //赋值给第一次触发的时间，这样就保存了第二次触发的时间
    }
  };
}


/*函数防抖*/
export function debounce(fn, interval) {
  var timer;
  var gapTime = interval || 1000; //间隔时间，如果interval不传，则默认1000ms
  return function () {
    clearTimeout(timer);
    var context = this;
    var args = arguments; //保存此处的arguments，因为setTimeout是全局的，arguments不是防抖函数需要的。
    timer = setTimeout(function () {
      fn.call(context, args);
    }, gapTime);
  };
}

// 时间戳转换
export function timetrans(date) {
  date = date.replace(/-/g, '/')
  var date = new Date(date); //如果date为13位不需要乘1000
  // console.log({date})
  var Y = date.getFullYear(); //不需增加一年减一
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var D = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours());
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

  return Y + '年' + M + '月' + D + '日';
}

// 获取数组三个最大的值
function noThree(arr) {
  var max = arr[0];
  var secmax = 0;
  var sub = 0;
  var secsub = 0;
  var thmax = 0;
  var thsub = 0;
  for (var i = 0; i < arr.length; i++) {
    arr[i]['sort'] = 99;
    if (arr[i] > max) {
      thmax = secmax;
      thsub = secsub;
      secmax = max;
      secsub = sub;
      max = arr[i];
      sub = i;
    } else if (arr[i] > secmax) {
      secmax = arr[i];
      secsub = i;
    } else {
      thmax = arr[i];
      thsub = i;
    }
  }

}



// WEBPACK FOOTER //
// ./src/utils/util.js